var _ref2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCamera = function SvgCamera(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 28.22,
    height: 19.006,
    viewBox: "0 0 28.22 19.006",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2 || (_ref2 = React.createElement("g", {
    id: "Group_10719",
    "data-name": "Group 10719",
    transform: "translate(-7964.413 -3544)"
  }, React.createElement("path", {
    id: "Path_28046",
    "data-name": "Path 28046",
    d: "M4,1.836c-1.654,0-2.879.734-2.879,2.664A2.693,2.693,0,0,0,4,7.429,2.65,2.65,0,0,0,6.821,4.5C6.821,2.57,5.654,1.836,4,1.836M4,0A4.272,4.272,0,0,1,8,4.5,4.272,4.272,0,0,1,4,9,4.272,4.272,0,0,1,0,4.5,4.272,4.272,0,0,1,4,0Z",
    transform: "translate(7979.197 3549.986)",
    fill: "#ded7d7"
  }), React.createElement("path", {
    id: "Path_28045",
    "data-name": "Path 28045",
    d: "M2.724,5.154,8.885,3.5l3.251,12.131-.068,1.378L6.676,18.457l-.989-.609Z",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 7966.559, 3542.036)",
    fill: "#ded7d7"
  }), React.createElement("path", {
    id: "Path_28042",
    "data-name": "Path 28042",
    d: "M30.576,29.928V22.949a1.464,1.464,0,0,0-.879-1.362A3.882,3.882,0,0,0,28.42,21.5h-1.39c-.34-.851-.681-1.7-1.05-2.553a1.124,1.124,0,0,0-1.163-.652H17.668a1.779,1.779,0,0,0-1.021.17,1.46,1.46,0,0,0-.454.709c-.142.312-.255.652-.4.965-.2.454-.369.908-.567,1.362H10.547v-.766A1.023,1.023,0,0,0,9.5,19.715H8.221a1.069,1.069,0,0,0-1.163.879c-.028.284-.028.6-.028.879H6.6a1.425,1.425,0,0,0-1.5,1.418V34.751a1.444,1.444,0,0,0,1.39,1.532c1.362.028,2.752,0,4.114,0H29.015a2.752,2.752,0,0,0,.482-.028,1.427,1.427,0,0,0,1.135-1.39C30.632,33.219,30.576,31.573,30.576,29.928ZM16.249,20.651a13.972,13.972,0,0,1,.624-1.5c.113-.255.4-.227.652-.227h6.95a1.759,1.759,0,0,1,.766.057c.17.085.2.312.284.482.142.312.255.624.4.965.142.369.284.738.454,1.078H15.937C16.022,21.218,16.136,20.935,16.249,20.651Zm-8.6.057c.057-.511.766-.369,1.106-.369s1.05-.142,1.106.369a7.414,7.414,0,0,1,0,.794H7.653A7.414,7.414,0,0,1,7.653,20.708Zm-.511,14.95H6.518a.787.787,0,0,1-.794-.766V23.4a1.65,1.65,0,0,1,.113-.908c.284-.482.993-.4,1.5-.369H11a.907.907,0,0,1,.539.142c.369.255.312.652.312,1.021v8.851c0,.908.028,1.816,0,2.7a.745.745,0,0,1-.766.766h-.511C9.412,35.658,8.277,35.658,7.143,35.658Zm22.809-.794a.769.769,0,0,1-.766.794H12.221a1.62,1.62,0,0,0,.255-.908V22.921a1.291,1.291,0,0,0-.227-.766H29.214a.8.8,0,0,1,.766.851V34.353A2.758,2.758,0,0,0,29.951,34.864Z",
    transform: "translate(7962 3525.705)",
    fill: "#3c3c3b"
  }), React.createElement("path", {
    id: "Path_28043",
    "data-name": "Path 28043",
    d: "M49.282,39.485a4.6,4.6,0,1,0,4.872,2.124A4.7,4.7,0,0,0,49.282,39.485Zm4.305,6.571a3.966,3.966,0,1,1-.34-4.588A3.923,3.923,0,0,1,53.587,46.056Z",
    transform: "translate(7933 3510.597)",
    fill: "#3c3c3b"
  }), React.createElement("path", {
    id: "Path_28044",
    "data-name": "Path 28044",
    d: "M53.636,44.971A3.033,3.033,0,0,0,51.2,47.945a3.132,3.132,0,0,0,2.011,2.861,3.008,3.008,0,0,0,3.6-4.418A3.032,3.032,0,0,0,53.636,44.971Zm2.634,4.249a2.406,2.406,0,0,1-2.521,1.1,2.448,2.448,0,0,1-1.954-2.351,2.412,2.412,0,0,1,4.277-1.529A2.385,2.385,0,0,1,56.27,49.219Z",
    transform: "translate(7928.985 3506.639)",
    fill: "#3c3c3b"
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCamera, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/camera.f750b3cf.svg";
export { ForwardRef as ReactComponent };